var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pg-main-layout"},[_c('Navbar'),_vm._v(" "),_c('ShutdownBanner'),_vm._v(" "),_c('div',{staticClass:"pg-main-layout__content",class:{
      'with-pro-banner': true
    }},[(_vm.subLayoutData)?_c(_vm.getSubLayoutComponent,{tag:"component",attrs:{"layoutProps":_vm.getSubLayoutProps,"subLayoutData":_vm.getChildLayoutData}},[_vm._t("default")],2):_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-483b27e7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/NavLayout.vue
// module id = null
// module chunks = 